// src/pages/CreateChannelModal.jsx
import React, { useState } from "react";

function CreateChannelModal({ onClose, onCreate }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  return (
    <div className="contacts-form-overlay">
      <div className="contacts-form">
        <h3 className="form-title">Create Channel</h3>
        <div className="form-body">
          <div className="input-group">
            <input
              type="text"
              placeholder=" "
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label>Channel Name</label>
          </div>
          <div className="input-group">
            <textarea
              placeholder=" "
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <label>Description</label>
          </div>
          <div className="form-buttons">
            <button
              type="button"
              className="btn-primary"
              disabled={!name.trim()}
              onClick={() => onCreate(name.trim(), description.trim())}
            >
              Create
            </button>
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateChannelModal;